import React from 'react';
import cx from 'classnames';

export interface OverlayProps {
  className?: string;
  orderClassName?: string;
  orderNumber?: number;
}

export function Overlay({
  className,
  orderClassName,
  orderNumber,
}: OverlayProps) {
  return (
    <div
      className={cx(className, [
        'absolute group z-10 w-full h-full flex hover:v2-bg-black/50',
        'items-center justify-center cursor-pointer transition-all',
      ])}
    >
      <span
        className={cx(orderClassName, [
          'transition-opacity opacity-0 group-hover:opacity-100',
          'w-12 h-12 v2-bg-yellow-500 rounded-full items z-20',
          'flex justify-center items-center font-bold text-[21px]',
        ])}
      >
        {orderNumber}
      </span>
    </div>
  );
}
